import WidgetAdvertisements from './WidgetAdvertisements';

export default WidgetAdvertisements;
